import React from "react";
import { Link } from "react-router-dom";

export function HomeLogoLink({ logo }) {
    return (
        <Link to="/">
            <img
                className=""
                style={{
                    height: 32,
                    margin: 16,
                    maxWidth: 168,
                }}
                src={logo}
                alt="logo"
            />
        </Link>
    );
}
